import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  // 语音陪聊
  {
    // 陪聊中心
    path: '/ChatCenter',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-ChatCenter" */ '~/pages/ChatCenter')
    ),
  },
  {
    // 陪聊-招募落地
    path: '/ChatCenter/apply',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatCenter-apply" */ '~/pages/ChatCenter/Apply'
        )
    ),
  },
  {
    // 陪聊-招募成功引导页
    path: '/ChatCenter/apply/guide',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatCenter-apply-guide" */ '~/pages/ChatCenter/Apply/Guide'
        )
    ),
  },
  {
    // 陪聊-历史通知
    path: '/ChatCenter/history',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatCenter-history" */ '~/pages/ChatCenter/History'
        )
    ),
  },
  //   视频陪聊
  {
    // 陪聊中心
    path: '/VideoChatCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-VideoChatCenter" */ '~/pages/VideoChatCenter'
        )
    ),
  },
  {
    // 陪聊-历史通知
    path: '/VideoChatCenter/history',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-VideoChatCenter-history" */ '~/pages/VideoChatCenter/History'
        )
    ),
  },
  {
    // 视频陪聊打分
    path: '/VideoChat/Rating',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-VideoChat-Rating" */ '~/pages/VideoChatCenter/Rating'
        )
    ),
  },

  {
    // 视频陪聊 申请
    path: '/VideoChat/Apply',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-VideoChat-Apply" */ '~/pages/VideoChatCenter/Apply'
        )
    ),
  },
  //   达人、团长中心
  {
    //   达人中心
    path: '/TalentsCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter" */ '~/pages/TalentsCenter'
        )
    ),
  },
  {
    //   团长中心
    path: '/TalentsLeaderCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsLeaderCenter" */ '~/pages/TalentsCenter/Leader'
        )
    ),
  },
  {
    // 邀请达人
    path: '/TalentsCenter/InviteAnchor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenterInviteAnchor" */ '~/pages/TalentsCenter/InviteAnchor'
        )
    ),
  },
  {
    // 历史通知
    path: '/TalentsCenter/History',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenterHistory" */ '~/pages/TalentsCenter/History'
        )
    ),
  },
  {
    // 任务
    path: '/TalentsCenter/Tasks',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenterTasks" */ '~/pages/TalentsCenter/Tasks'
        )
    ),
  },
  {
    path: '/TalentsCenter/news',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter-news" */ '~/pages/TalentsCenter/news'
        )
    ),
  },

  // 工会长和主播共用的各种支付方式的绑定页面
  {
    path: '/TalentsCenter/GatherInfo',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter-GatherInfo" */ '~/pages/TalentsCenter/GatherInfo'
        )
    ),
  },
  {
    path: '/TalentsCenter/GatherInfo/PayoneerNew',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter-GatherInfo-PayoneerNew" */ '~/pages/TalentsCenter/GatherInfo/PayoneerNew'
        )
    ),
  },
  {
    path: '/TalentsCenter/GatherInfo/PayoneerOther',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter-GatherInfo-PayoneerOther" */ '~/pages/TalentsCenter/GatherInfo/PayoneerOther'
        )
    ),
  },
  // 生成他人绑定Payoneer专属链接
  {
    path: '/TalentsCenter/GatherInfo/PayoneerOther/Link',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter-GatherInfo-PayoneerOthe-Link" */ '~/pages/TalentsCenter/GatherInfo/PayoneerOther/link'
        )
    ),
  },
  // 工会长和主播共用的改变默认收款方式
  {
    path: '/TalentsCenter/SalaryMode',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter-SalaryMode" */ '~/pages/TalentsCenter/GatherInfo/SalaryMode'
        )
    ),
  },
  {
    path: '/TalentsCenter/paymentway',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter-PaymentWay" */ '~/pages/TalentsCenter/PaymentWay'
        )
    ),
  },
  // BD接受邀请
  {
    path: '/chatBD/hunting/invite/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatBD-HuntingToBeBD" */ '~/pages/ChatBD/ToBeBD'
        )
    ),
  },
  // chat 挖猎中心
  {
    path: '/chatBD/hunting/main',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatBD-HuntingMain" */ '~/pages/ChatBD/Main'
        )
    ),
  },
  // chat 挖猎中心规则
  {
    path: '/chatBD/hunting/rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatBD-HuntingRules" */ '~/pages/ChatBD/Rules'
        )
    ),
  },
  // 团长信息填写页面
  {
    path: '/chatBD/guildsettled',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatBD-Hunting-GuildSettled" */ '~/pages/ChatBD/GuildSettled'
        )
    ),
  },
  // Chat cp
  // 等级和任务
  {
    path: '/ChatCp/LvAndTask',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatCp-LvAndTask" */ '~/pages/ChatCp/LvAndTask'
        )
    ),
  },
  // 规则
  {
    path: '/ChatCp/Rules',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatCp-Rules" */ '~/pages/ChatCp/Rules'
        )
    ),
  },
  // 文字和视频小助手页面
  {
    // 文字和视频小助手-主页面
    path: '/ChatWork',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-ChatWork" */ '~/pages/ChatWork')
    ),
  },
  {
    // 文字和视频小助手-文字等级页
    path: '/ChatWork/Rules/Text',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatWork-Rules-Text" */ '~/pages/ChatWork/Rules/Text'
        )
    ),
  },
  {
    // 文字和视频小助手-视频等级页
    path: '/ChatWork/Rules/Video',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatWork-Rules-Video" */ '~/pages/ChatWork/Rules/Video'
        )
    ),
  },
  {
    // 文字和视频小助手-文字引导页
    path: '/ChatWork/Guide/Text',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatWork-Guide-Text" */ '~/pages/ChatWork/Guide/Text'
        )
    ),
  },
  {
    // 文字和视频小助手-视频引导页
    path: '/ChatWork/Guide/Video',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ChatWork-Guide-Video" */ '~/pages/ChatWork/Guide/Video'
        )
    ),
  },
  {
    // 7日心动之旅
    path: '/Chat/LoveJourney',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Chat-LoveJourney" */ '~/pages/LoveJourney'
        )
    ),
  },
  {
    // 达人自裂变邀请页
    path: '/Chat/SelfFission',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Chat-SelfFission" */ '~/pages/SelfFission'
        )
    ),
  },
  {
    // 心愿单
    path: '/Chat/Wish',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Chat-Wish" */ '~/pages/WishList/pages/Main'
        )
    ),
  },
  {
    // 心愿单
    path: '/Chat/Wish/Rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Chat-Wish-Rank" */ '~/pages/WishList/pages/Rank'
        )
    ),
  },
  {
    // 积分规则
    path: '/TalentsCenter/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TalentsCenter-Rule" */ '~/pages/TalentsCenter/Rule/index'
        )
    ),
  },
] as RouteConfig[]
